import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCuentas, getBancos, guardarCuenta, marcarPredeterminada, eliminarCuentaBan } from "../api";
import { toast } from "react-hot-toast";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import { motion } from "framer-motion";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Cuentas = () => {
  const [cuentas, setCuentas] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [loadingCuentas, setLoadingCuentas] = useState(true);
  const [showAddAccount, setShowAddAccount] = useState(false);
  const [loadingAccion, setLoadingAccion] = useState(false);
  const [cuentaSeleccionada, setCuentaSeleccionada] = useState(null);
  const id_perfil = localStorage.getItem("id_perfil");
  const navigate = useNavigate();
  const showSplash = useDynamicSplash(loadingCuentas);

  // Historial para que swipe-back regrese a /perfil
  useEffect(() => {
    window.history.replaceState({}, "", "/perfil");
    window.history.pushState({}, "", "/cuentasretiro");
  }, []);

  const cargarDatos = async () => {
    setLoadingCuentas(true);
    document.body.style.overflow = "hidden";

    try {
      const resCuentas = await getCuentas(id_perfil);
      const resBancos = await getBancos(id_perfil);

      setCuentas(resCuentas.cuentas || []);
      setBancos(resBancos.bancos || []);
      setLoadingCuentas(false);
      document.body.style.overflow = "auto";
      window.scrollTo(0, 0);
    } catch (error) {
      setLoadingCuentas(false);
      document.body.style.overflow = "auto";
      toast.error("Error al cargar los datos.");
    }
  };  

  useEffect(() => {
    if (id_perfil) {
      cargarDatos();
    }
  }, [id_perfil]);

  const abrirOpciones = (cuenta) => {
    setCuentaSeleccionada(cuenta);
  };

  const cerrarOpciones = () => {
    setCuentaSeleccionada(null);
  };

  const confirmarEliminarCuenta = () => {
    toast((t) => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <span>¿Estás seguro de que deseas eliminar la cuenta? <br /><b>Esta acción no puede revertirse.</b></span>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            onClick={async () => {
              toast.dismiss(t.id);
              cerrarOpciones();
              setLoadingAccion(true);
              const res = await eliminarCuentaBan(cuentaSeleccionada.id_cuenta);
              setLoadingAccion(false);
              if (res.success) {
                toast.success("Cuenta eliminada");
                cargarDatos();
              } else {
                toast.error(res.error || "Error al eliminar");
              }
            }}
            style={{
              backgroundColor: '#ff5c5c',
              color: '#fff',
              border: 'none',
              padding: '5px 10px',
              borderRadius: 5,
              fontSize: 14
            }}
          >
            Eliminar
          </button>
          <button
            onClick={() => toast.dismiss(t.id)}
            style={{
              border: '1px solid #ccc',
              padding: '5px 10px',
              borderRadius: 5,
              fontSize: 14
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    ), { duration: 10000 });
  };

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!showSplash && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
        {loadingAccion && (
            <div style={{
                position: "fixed",
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <div style={{
                width: "60px",
                height: "60px",
                border: "6px solid #f3f3f3",
                borderTop: "6px solid #3498db",
                borderRadius: "50%",
                animation: "spin 1s linear infinite"
                }}></div>
                <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                `}</style>
            </div>
            )}
      <div className="connections-container">
        <div className="back-container">
          <button className="back-btn" onClick={() => navigate("/perfil")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
              <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292" />
            </svg>
          </button>
        </div>
        <h2 className="connections-title">Tus cuentas de retiro</h2>
        <div style={{
            backgroundColor: "#fff7f0",
            border: "1px solid #fddbb3",
            color: "#6c4005",
            padding: "12px 16px",
            borderRadius: "8px",
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            marginTop: "20px"
            }}>
            <svg  fill="#f57c00"
                style={{ marginRight: "10px", flexShrink: 0 }}xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
                <path fill="currentColor" d="M12 16.5q.214 0 .357-.144T12.5 16v-4.5q0-.213-.144-.356T11.999 11t-.356.144t-.143.356V16q0 .213.144.356t.357.144M12 9.577q.262 0 .439-.177t.176-.438t-.177-.439T12 8.346t-.438.177t-.177.439t.177.438t.438.177M12.003 21q-1.867 0-3.51-.708q-1.643-.709-2.859-1.924t-1.925-2.856T3 12.003t.709-3.51Q4.417 6.85 5.63 5.634t2.857-1.925T11.997 3t3.51.709q1.643.708 2.859 1.922t1.925 2.857t.709 3.509t-.708 3.51t-1.924 2.859t-2.856 1.925t-3.509.709M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8" strokeWidth="0.7" stroke="currentColor" />
            </svg>
            <span>
                <strong>Importante:</strong> La cuenta que marques como predeterminada será utilizada para enviarte tus fondos. Asegúrate de que todos los datos sean correctos y estén actualizados.
            </span>
            </div>
      </div>

      <div className="feature-list">
        {cuentas.length > 0 ? (
          cuentas.map((cuenta) => (
            <div className="feature-item" onClick={() => abrirOpciones(cuenta)} key={cuenta.id_cuenta}>
              <div className="feature-text">
                <h3 style={{ marginBottom: 4 }}>{cuenta.nombre}</h3>
                <p style={{ fontSize: 14, marginBottom: 4 }}>
                  {cuenta.tipo.toUpperCase()} - {cuenta.no_cuenta}
                </p>
                <p style={{ fontSize: 13, color: "#888" }}>
                  Banco: <b>{cuenta.banco}</b>
                </p>
                <span className={`badge ${parseInt(cuenta.predeterminada) === 1 ? "badge-v" : "badge-w"}`}>
                    {parseInt(cuenta.predeterminada) === 1 ? "Predeterminada" : "Secundaria"}
                </span>

              </div>
            </div>
          ))
        ) : (
          <div className="no-data-wrapper" style={{height:300, marginTop:95}}>
            <div className="no-data">
              <img src="/assets/images/empty.svg" alt="Sin referidos" />
              <p>
              Aún no has vínculado cuentas de retiro.
              </p>
            </div>
          </div>
        )}
      </div>

      {cuentaSeleccionada && (
        <>
            <div className="overlay active" onClick={cerrarOpciones}></div>
            <div className="bottom-modal">
            <div className="step">
                <h3 style={{ textAlign: "center", marginBottom: 15, fontSize:18, fontWeight: "bold" }}>¿Qué quieres hacer?</h3>
                <button
                    className="btn-option"
                    onClick={async () => {
                        cerrarOpciones();
                        setLoadingAccion(true);
                        const res = await marcarPredeterminada(id_perfil, cuentaSeleccionada.id_cuenta);
                        if (res.success) {
                            toast.dismiss();
                            toast.success("Cuenta marcada como predeterminada");
                            cargarDatos();
                        } else {
                            toast.dismiss();  
                            toast.error(res.error || "No se pudo actualizar");
                        }
                        setLoadingAccion(false);
                    }}
                >
                Establecer como predeterminada
                </button>

                <button
                    className="btn-option danger"
                    onClick={confirmarEliminarCuenta}
                >
                Eliminar cuenta
                </button>

                <button className="btn-cancel" onClick={cerrarOpciones}>
                Cancelar
                </button>
            </div>
            </div>
        </>
        )}

        {showAddAccount && (
          <AddAccount
            onClose={() => setShowAddAccount(false)}
            bancos={bancos}
            userId={id_perfil}
            onRefresh={cargarDatos}
            setLoadingAccion={setLoadingAccion}
          />
        )}
    </div>
    </motion.div>
    )}
      <button className="fab-add" onClick={() => setShowAddAccount(true)}>+</button>
    </>
  );
};  

const AddAccount = ({ onClose, bancos, userId, onRefresh, setLoadingAccion  }) => {
  const [nombre, setNombre] = useState("");
  const [tipo, setTipo] = useState("monetaria");
  const [noCuenta, setNoCuenta] = useState("");
  const [banco, setBanco] = useState("");
  const [error, setError] = useState("");

  const handleGuardar = async () => {
    if (!nombre || !tipo || !noCuenta || !banco) {
      setError("Todos los campos son obligatorios.");
      return;
    }
    onClose();
    setLoadingAccion(true);
    const res = await guardarCuenta({
      id_perfil: userId,
      nombre,
      tipo,
      no_cuenta: noCuenta,
      banco,
    });
    setLoadingAccion(false);
    if (res.success) {
      toast.dismiss();
      toast.success("Cuenta registrada correctamente.");
      onRefresh();
    } else {
      toast.dismiss();
      toast.error(res.error || "Error al guardar la cuenta.");
    }
  };

  return (
    <div className="overlay show" onClick={(e) => e.target.classList.contains("overlay") && onClose()}>
      <div className="bottom-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
        <div className="step">
          <h2>Víncula una cuenta de retiro</h2>

          <input
            type="text"
            placeholder="Nombre de la cuenta"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            className="input-style"
          />

          <select className="input-style" value={tipo} onChange={(e) => setTipo(e.target.value)} style={{ marginTop: 10 }}>
            <option value="monetaria">MONETARIA</option>
            <option value="ahorro">AHORRO</option>
          </select>

          <input
            type="number"
            placeholder="Número de cuenta"
            value={noCuenta}
            onChange={(e) => setNoCuenta(e.target.value)}
            className="input-style"
            style={{ marginTop: 10 }}
          />

          <select className="input-style" value={banco} onChange={(e) => setBanco(e.target.value)} style={{ marginTop: 10 }}>
            <option value="">Selecciona un banco</option>
            {bancos.map((b) => (
              <option key={b.id_banco} value={b.id_banco}>{b.nombre}</option>
            ))}
          </select>

          {error && <p style={{ color: 'red', fontSize: '14px', paddingTop: 20 }}>{error}</p>}

          <div className="buttons">
            <button onClick={handleGuardar}>Guardar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cuentas;
